import Service from "@/service/Service";
import Member from "@/Member";

const MemberService = {
    getForId: async function (memberId, buyGroup) {
        let errorResponseStatus;
        let errorName;
        const response = await Service.api().get("/members/" + memberId).catch((error) => {
            errorResponseStatus = error.response.status;
            errorName = error.response.data.errorName
        })
        if (errorResponseStatus === 401 && errorName === 'needToBeAuthenticated') {
            return false;
        } else {
            return Member.format(response.data, buyGroup);
        }
    },
    getPublicForId: async function (memberId) {
        const response = await Service.api().get("/members/" + memberId + "/public")
        return Member.format(response.data);
    },
    update: async function (memberId, member) {
        return Service.api().put("/members/" + memberId, member);
    }    
};
export default MemberService;
